import { initFirebase } from "./firebase-app"
import { getFirestore } from "firebase/firestore";

const db = getFirestore(initFirebase());

export const initFirestore = () => {
  return db;
}